// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.wrapped-text[data-v-b14756ee] {\n\tdisplay: inline-block;\n\twhite-space: normal;\n\tword-break: break-word;\n\tmax-width: 200px;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
